// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vs-overflow .vs__selected-options{overflow:auto;scrollbar-width:none}.vs-overflow .vs__selected-options::-webkit-scrollbar{width:4px!important;height:4px!important}.vs__dropdown-menu{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}", ""]);
// Exports
module.exports = exports;
